import { reducerWrapper } from '../support/utils';
import {
  GET_CUSTOM_CALCULATIONS,
  SET_CUSTOM_CALCULATION,
  REMOVE_CUSTOM_CALCULATION,
  CustomCalculationAction,
} from '../actions/CustomCalculation/CustomCalculationActions';
import type { CustomCalculationRecord } from '../types/customCalculations';

type ReducerRecords = Record<string, CustomCalculationRecord>;

export type CustomCalculationReducer = {
  loading: boolean;
  error: any;
  records: ReducerRecords;
};

const INIT_STATE: CustomCalculationReducer = {
  loading: true,
  error: null,
  records: {},
};

const Handler = (state: CustomCalculationReducer, action: CustomCalculationAction): CustomCalculationReducer => {
  switch (action.type) {
    case GET_CUSTOM_CALCULATIONS.response: {
      const records: ReducerRecords = {};
      action.data.forEach((record) => (records[record.id] = record));

      return { ...state, loading: false, records };
    }

    case SET_CUSTOM_CALCULATION: {
      const records = { ...state.records, [action.data.id]: action.data };
      return { ...state, records };
    }

    case REMOVE_CUSTOM_CALCULATION: {
      const records = { ...state.records };
      delete records[action.data.id];
      return { ...state, records };
    }

    default: {
      return state;
    }
  }
};

const TypelessHandler = (state: any, action: any) => {
  return Handler(state, action);
};

const CustomCalculation = reducerWrapper(INIT_STATE, TypelessHandler, {
  request: [GET_CUSTOM_CALCULATIONS, SET_CUSTOM_CALCULATION],
  error: [GET_CUSTOM_CALCULATIONS],
});

export default CustomCalculation;
